import React from 'react';

// Components
import { FormFieldText } from 'components/lib/FormFields';
import { preventNonNumericKeys } from 'utils/utils';

export class Payday extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <FormFieldText 
          label="Dia de Pagamento" 
          type="number" 
          forceInvalid={!this.props.isValid} 
          isValid={this.props.isValid} 
          errorMessage={this.props.errorMessage} 
          style={{ width: 140, marginRight: 20 }} 
          onKeyDown={preventNonNumericKeys}
          onChange={(e) => this.props.onChange(e)} 
          valueDefault={this.props.defaultValue}
          disabled={this.props.disabled}
        />
      </React.Fragment>
    );
  }
}

export default Payday;
